import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Typography,
  Checkbox,
  FormControlLabel,
  ListItemAvatar,
  Avatar,
  DialogActions,
  Box,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import authenticate from "@truto/truto-link-sdk"; // Import the Truto Link SDK
import GoogleIcon from "../../../../../../Assets/Images/google.png";
import adpIcon from "../../../../../../Assets/Images/adv.png";
import alexisIcon from "../../../../../../Assets/Images/Alexis.png";
import BambooHRIcon from "../../../../../../Assets/Images/bambooHr.png";
import bretheIcon from "../../../../../../Assets/Images/breathe.png";
import ceridianIcon from "../../../../../../Assets/Images/ceridian.png";
import charlieIcon from "../../../../../../Assets/Images/charlie.png";
import ArrowIconBtn from "../../../../../../components/RightArrowIconButton/ArrowIconBtn";
import { useMutation } from "@apollo/client";
import { GENERATE_TRUTO_LINK_TOKEN } from "../../../../../../apis/organization-apis/people-apis/peopleApis";
import { LoadingButton } from "@mui/lab";

const providers = [
  { name: "Google Workspace", icon: GoogleIcon },
  { name: "ADP Workforce", icon: adpIcon },
  { name: "Alexis HR", icon: alexisIcon },
  { name: "BambooHR", icon: BambooHRIcon },
  { name: "Breathe", icon: bretheIcon },
  { name: "Ceridian", icon: ceridianIcon },
  { name: "Charlie", icon: charlieIcon },
];

function AddStaffFromProviderDialog({ open, onClose, close }) {
  const [openProviderDialog, setOpenProviderDialog] = useState(null);
  const [generateTrutoLinkToken, { loading }] = useMutation(
    GENERATE_TRUTO_LINK_TOKEN
  );

  const handleProviderClick = (providerName) => {
    setOpenProviderDialog(providerName);
  };

  const handleCloseProviderDialog = () => {
    setOpenProviderDialog(null);
  };

  const handleConnect = async () => {
    // const tenantId = process.env.REACT_APP_TENANT_ID;
    // const redirectUri = window.location.href;

    try {
      const { data } = await generateTrutoLinkToken({
        variables: {
          // tenant_id: tenantId,
          // redirect_uri: redirectUri,
        },
      });

      if (!loading) {
        const linkToken = data.generateTrutoLinkToken.linkToken;

        onClose();
        setOpenProviderDialog(null);
        close();

        if (!linkToken) {
          alert("Failed to generate link token. Please try again.");
          return;
        }

        // Invoke Truto Link SDK
        const response = await authenticate(linkToken, {
          noBack: true, // Disable the "Back" button
          skipRapidForm: false, // Show the RapidForm UI if defined
          iframe: true, // Open the UI inside an iframe
          // integration: 'zohopeople',
        });

        console.log(
          `Successfully connected to ${openProviderDialog}: ${response.integration}`
        );
      }
    } catch (error) {
      console.error("Error during Truto Link connection:", error);
      alert("Failed to connect. Please try again.");
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle fontWeight="bold">
          Add Staff From Provider{" "}
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <List>
            {providers.map((provider, index) => (
              <ListItem
                key={index}
                button
                onClick={() => handleProviderClick(provider.name)}
                sx={{
                  border: "1px solid #C5C9CF",
                  borderRadius: "12px",
                  margin: "1rem 0",
                  cursor: "pointer",
                }}
              >
                <ListItemAvatar>
                  <Avatar src={provider.icon} alt={provider.name} />
                </ListItemAvatar>
                <ListItemText primary={provider.name} />

                <ArrowIconBtn
                  onClick={() => handleProviderClick(provider.name)}
                  fontSize="small"
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
      </Dialog>

      {providers.map((provider, index) => (
        <Dialog
          key={index}
          open={openProviderDialog === provider.name}
          onClose={handleCloseProviderDialog}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle fontWeight={"bold"}>
            Setup {provider.name} Integration{" "}
            <IconButton
              aria-label="close"
              onClick={handleCloseProviderDialog}
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <Divider />
          <DialogContent>
            <Typography variant="p" gutterBottom fontWeight="bold">
              Setup {provider.name} integration to ensure user list is synced
              for managing onboarding and offboarding status of each of the
              users.
            </Typography>
            <ol style={{ fontSize: "14px" }}>
              <li>
                User needs to create a service account to connect{" "}
                {provider.name} with Regodit.
              </li>
              <li style={{ margin: "10px 0" }}>
                After clicking on Connect to {provider.name}, follow the steps
                on UI to create a service account with the username and email
                provided to you during connection flow.
              </li>
            </ol>
            <Typography variant="body2" gutterBottom>
              * Make sure you have necessary privileges to create a service
              account.
            </Typography>
          </DialogContent>
          <Box sx={{ background: "#F7F7FC" }} px={2}>
            {" "}
            <FormControlLabel
              control={<Checkbox />}
              label="I am ready to create a service account."
            />
          </Box>
          <DialogActions>
            <LoadingButton
              loading={loading}
              variant="contained"
              color="primary"
              onClick={handleConnect}
            >
              Connect
            </LoadingButton>
          </DialogActions>
        </Dialog>
      ))}
    </>
  );
}

export default AddStaffFromProviderDialog;
